<div class="iconpicker">
  <div class="category" *ngFor="let category of categoryList">
    <h2>{{ 'Page.IconCategories.' + category | translate }}</h2>
    <ng-container *ngFor="let icon of iconList">
      <div class="icon" *ngIf="icon.Url.split('/')[1].toUpperCase() == category" (click)="SetIcon(icon)" loading="lazy">
        <img src="/assets/{{ icon.Url }}" alt="icon" title="{{ icon.Name }}">
      </div>
    </ng-container>
  </div>
</div>